import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';
import { FileRecord } from '../types/file-record';

export type CreateReferencesRequest = { sourceFileId: string; parentFolderId?: string; name: string }[];

async function createReferences(request: CreateReferencesRequest): Promise<PostResponseBody<FileRecord>> {
    const { data } = await api.post('/file-records/references', request);
    return data;
}

export function useCreateReferences(): UseMutationResult<PostResponseBody<FileRecord>, AxiosError, CreateReferencesRequest, unknown> {
    return useMutation(createReferences, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
        },
    });
}
